import FJModal from '@src/components/FJModals/FJModal';
import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import FJPublishAction from '@src/redux/action/FJPublishAction.ts';
import FJAddSocialSlice from '@src/redux/slice/modal/FJAddSocialSlice.ts';
import FJAddAccountPanel from '@src/components/FJModals/FJShareModal/FJAddAccount/FJAddAccountPanel.tsx';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';

const FJAddSocialModal = () => {
    const dispatch = useAppDispatch();
    const activeData = { youtube: true, linkedin: true };
    const isShow = useAppSelector(state => {
        return state.modal.bindSocial.isShow;
    });

    const _onClose = () => {
        FJRequirementsUtil.eaLog('add_account_window_close');
        dispatch(FJAddSocialSlice.actions.setIsShow(false));
    };

    const _onAddPlatform = (type: string) => {
        dispatch(FJPublishAction.addPublishPlatformAction(type, true));
    };

    return (
        <FJModal visible={isShow}>
            <FJAddAccountPanel activeData={activeData} onClose={_onClose} onAddPlatform={_onAddPlatform} />
        </FJModal>
    );
};

export default FJAddSocialModal;
